import styles from './to-do-list-no-results.module.scss';
import { clsx } from 'clsx';
import { Typography, Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { NegativeJourneyCategory, SelectedFilterCategory } from 'modules/dashboard/types';

type ToDoListNoResultsProps = {
  negativeJourneyType?: NegativeJourneyCategory;
  searchTerm?: string;
  selectedFilter?: string;
  selectedFilterType?: SelectedFilterCategory;
};

export const ToDoListNoResults = ({
  negativeJourneyType,
  searchTerm,
  selectedFilter,
  selectedFilterType
}: ToDoListNoResultsProps) => {
  switch (negativeJourneyType) {
    case NegativeJourneyCategory.search:
      return (
        <div className={clsx(styles.toDoListNoResultsContainer, styles.searchNoResults)}>
          <Icon icon={ICONS_ENUM.ACTION_2_YOUTUBE_SEARCHED_FOR} className={styles.icon} />
          <div className={styles.noSearchResultsText}>
            <Typography
              variant={Typography.VARIANT.B2}
              weight={Typography.WEIGHT.NORMAL}
              color={Typography.COLOR.INHERIT}
            >
              {searchTerm ? `No results found for “${searchTerm}”.` : 'No results found.'}
            </Typography>
            <Typography
              variant={Typography.VARIANT.B2}
              weight={Typography.WEIGHT.NORMAL}
              color={Typography.COLOR.INHERIT}
            >
              Please try another search.
            </Typography>
          </div>
        </div>
      );
    case NegativeJourneyCategory.filter:
      return (
        <div className={clsx(styles.toDoListNoResultsContainer, styles.filterNoResults)}>
          <div className={styles.filterNoResultsHeaderText}>
            <Icon icon={ICONS_ENUM.ACTION_2_INFO} className={styles.icon} />
            <Typography
              variant={Typography.VARIANT.B2}
              weight={Typography.WEIGHT.MEDIUM}
              color={Typography.COLOR.INHERIT}
            >
              {selectedFilterType === SelectedFilterCategory.toDoItem
                ? `There are no “${selectedFilter}” to-do items.`
                : `There are no to-do items “${selectedFilter}”.`}
            </Typography>
          </div>
          <Typography
            variant={Typography.VARIANT.B3}
            weight={Typography.WEIGHT.NORMAL}
            color={Typography.COLOR.INHERIT}
          >
            {selectedFilterType === SelectedFilterCategory.toDoItem
              ? `When a “${selectedFilter}” to-do item has been added, it will be displayed here.`
              : `When a to-do item “${selectedFilter}” has been added, it will be displayed here.`}
          </Typography>
        </div>
      );
    case NegativeJourneyCategory.manyFilters:
      return (
        <div className={clsx(styles.toDoListNoResultsContainer, styles.filterNoResults)}>
          <div className={styles.filterNoResultsHeaderText}>
            <Icon icon={ICONS_ENUM.ACTION_2_INFO} className={styles.icon} />
            <Typography
              variant={Typography.VARIANT.B2}
              weight={Typography.WEIGHT.MEDIUM}
              color={Typography.COLOR.INHERIT}
            >
              There are no to-do items that match the selected filters.
            </Typography>
          </div>
          <Typography
            variant={Typography.VARIANT.B3}
            weight={Typography.WEIGHT.NORMAL}
            color={Typography.COLOR.INHERIT}
          >
            When a to-do item has been added that matches the selected filters, it will be displayed
            here.
          </Typography>
        </div>
      );
    default:
      return <div className={styles.toDoListNoResultsContainer}>No results</div>;
  }
};
